<template>
  <div class="tabs_content">
    <section>
      <div class="filter search_only">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
      </div>

      <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="subscribers-advertising-banners">
          <table class="vypis">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <AdvertisingBannerRow
                v-for="advertisingBanner in entities"
                :advertisingBanner="advertisingBanner"
                :key="advertisingBanner.id"
                :isDeletable="isEditable"
                :id-subscriber="entity.id"
                :advertisingBannerTypes="advertisingBannerTypes"
                :selectedEntities="selectedEntities"
                @input="select"
                @deleteAdvertisingBanner="onDeleteAdvertisingBanner" />
            <tr v-if="entities.length === 0">
              <td colspan="7" v-translate>Nebylo nalezeno žádné marketingové oznámení.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-advertising-banners"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import AdvertisingBannerRow from "./AdvertisingBannerRow";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailAdvertisingBanners",
  components: { AdvertisingBannerRow },
  mixins: [listActions],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      entities: [],
      totalCount: 0,
    }
  },
  created(SubscriberService, AdvertisingBannerRecipientService) {
    this.subscriberService = SubscriberService
    this.advertisingBannerRecipientService = AdvertisingBannerRecipientService

    this.getEntities()
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getSubscriberAdvertisingBanners(this.entity.id, params).then((data) => {
        this.entities = data['advertising_banners']
        this.totalCount = data['totalCount']
      })
    },
    onDeleteAdvertisingBanner(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deleteAdvertisingBanner');
      } else {
        this.advertisingBannerRecipientService.deleteRecipient({
          id_subscriber: this.entity.id,
          id_advertising_banner: id,
          id_selected_operator: this.$_loggedUser_selectedOperatorId
        })
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.getEntities();
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeleteAdvertisingBanner(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getSubscriberAdvertisingBanners(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['advertising_banners']);
      })
    },
  },
  computed: {
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sAdvertisingBannerName' },
        { id: 2, name: this.$gettext('Přečteno na zařízení/celkem') },
        { id: 3, name: this.$gettext('Smazáno') },
        { id: 4, name: this.$gettext('Datum zobrazení'), column: 'sAdvertisingBannerShowAt' },
      ]
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'recipients_devices_read': {
          name: this.$gettext('Přečteno na zařízení/celkem'), callback: (entity) => {
            return entity.recipients_devices_read + ' / ' + entity.recipients_devices_read
          }
        },
        'timestamp_deleted': {
          name: this.$gettext('Smazáno'), callback: (entity) => {
            return entity.timestamp_deleted ? this.$_datetime_format(entity.timestamp_deleted) : ''
          }
        },
        'showAt': {
          name: this.$gettext('Datum zobrazení'), callback: (entity) => {
            return entity.timestamp_deleted ? this.$_datetime_format(entity.timestamp_deleted) : ''
          }
        },
      }
    },
    advertisingBannerTypes() {
      return {
        'info': this.$gettext('Informativní sdělení'),
        'maintenance_info': this.$gettext('Servisní informace'),
        'new_service': this.$gettext('Nová služba'),
        'fault': this.$gettext('Porucha'),
        'maintenance': this.$gettext('Servis'),
        'billing': this.$gettext('Platby')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/advertisingBanners/AdvertisingBanners.vue